import { Component, OnInit } from '@angular/core';
import { LocalstorageService } from '../../common/services/localstorage/localstorage.service';
import { AuthenticationService } from '../../views/authentication/authentication.service';

@Component({
  selector: 'app-widgets',
  templateUrl: './app-widgets.component.html',
  styleUrls: ['./app-widgets.component.scss']
})
export class AppWidgetsComponent implements OnInit {

  constructor(private localStorageService: LocalstorageService, public AuthService: AuthenticationService) { }
  selectedItem: any = null;
  _enableDrag: boolean = false;
  
  public SelWidgets: any[] = [];

  widgets: any[] = [
    {name: 'widgets.dif' , type: 'app-app-stats-dif', config: {payload: 'app-app-stats-dif', sizex: 21, sizey: 5, minWidth:50}, url: '/statistics' },
    {name: 'widgets.avg' , type: 'app-app-stats-avg', config: {payload: 'app-app-stats-avg', sizex: 22, sizey: 5, minWidth:50}, url: '/statistics' },
    {name: 'widgets.total_spending' , type: 'app-chart-total-spending', config: {payload: 'app-chart-total-spending', sizex: 43, sizey: 26, minWidth:50}, url:'/total-graph' },
    {name: 'widgets.topEC' , type: 'app-app-stats-top-ec', config: {payload: 'app-app-stats-top-ec', sizex: 43, sizey: 5, minWidth:50}, url: '/statistics' },
    {name: 'widgets.top2T' , type: 'app-app-stats-top-2t', config: {payload: 'app-app-stats-top-2t', sizex: 21, sizey: 5, minWidth:50}, url: '/statistics' },
    {name: 'widgets.top4T' , type: 'app-app-stats-top-4t', config: {payload: 'app-app-stats-top-4t', sizex: 22, sizey: 5, minWidth:50}, url: '/statistics' },
    {name: 'widgets.topUnit' , type: 'app-app-stats-top-units', config: {payload: 'app-app-stats-top-units', sizex: 43, sizey: 5, minWidth:50}, url: '/statistics' },
    {name: 'widgets.top' , type: 'app-app-stats-top-spenders', config: {payload: 'app-app-stats-top-spenders', sizex: 43, sizey: 5, minWidth:50}, url: '/statistics' },
    {name: 'widgets.optimization_analysis' , type: 'app-chart-optimization', config: {payload: 'app-chart-optimization', sizex: 43, sizey: 6, minWidth:50}, url: '/optimization-graph' },
    {name: 'widgets.contract_lines' , type: 'app-chart-contractLines', config: {payload: 'app-chart-contractLines', sizex: 43, sizey: 7, minWidth:50}, url: '/overview-lines' },
    {name: 'widgets.numLines' , type: 'app-app-stats-total-lines', config: {payload: 'app-app-stats-total-lines', sizex: 22, sizey: 5, minWidth:50}, url: '/statistics' },
    {name: 'widgets.avgUsers' , type: 'app-app-stats-avg-users', config: {payload: 'app-app-stats-avg-users', sizex: 22, sizey: 5, minWidth:50}, url: '/statistics' }
  ];


  ngOnInit() {
    this.AuthService.authenticationChanged.subscribe(item => {
      if (this.AuthService.isLogged){
        this.AuthService.getUserMenu().subscribe( response => {
          if (response){
            let resJSON = JSON.parse(response.menu);
            console.info (resJSON);
            resJSON.forEach(element => {
              if (element.children){
                element.children.forEach(item => {
                  this.widgets.forEach(wid => {
                    if (item.url == wid.url) {
                      let index = this.widgets.indexOf(wid);
                      this.SelWidgets.push(wid);
                    }
                  });
                });
              }
            });
            console.info ( this.SelWidgets);
          }
          else {
            this.SelWidgets = this.widgets;
          }
        });
      }
    });
  }

  set enableDrag(value) {
    this._enableDrag = value;
    this.localStorageService.sendMessage.emit({message:'dashboard_isdraggable', value: value});
  }

  get enableDrag() {
    return this._enableDrag;
  }

  add() {
    this.localStorageService.sendMessage.emit({message:'addWidget', value: this.selectedItem});
  }

  saveChanges() {
    this.localStorageService.sendMessage.emit({message:'saveWidgets'});    
  }

}



// WEBPACK FOOTER //
// ./src/app/components/app-widgets/app-widgets.component.ts